<template>
  <div class="fabricationContainer">
    <div style="height:500px">
      <LMap
          ref="map"
          :zoom="zoom"
          :center="[43.215045, 0.112767]"
      >
        <LTileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&amp;copy; <a href=&quot;https://www.openstreetmap.org/&quot;>OpenStreetMap</a> contributors"
            layer-type="base"
            name="OpenStreetMap"
        />
        <LMarker :latLng="coordinates">
          <LPopup v-show="true">
            <span class="fw-bold">ALTELA</span> <br/>
            <span>4 Rue des Ramendeuses, 65600 Séméac</span> <br/>
            <span>France</span>
          </LPopup>
        </LMarker>
      </LMap>
    </div>
  </div>
</template>

<script setup lang="ts">
const zoom = ref(17)
const coordinates = [43.215045, 0.112767];
</script>

<style scoped>
.fabricationContainer {
  background: #093888;
}

.leaflet-popup-content {
  max-width: 250px; /* Adjust the width as needed */
  overflow-wrap: break-word; /* Allow text wrapping within the width */
}

.leaflet-popup-content span {
  font-family: Roboto, sans-serif;
  font-size: 16px;
}

.leaflet-popup-content span.fw-bold {
  font-family: Panton, sans-serif;
}
</style>